webpackJsonp([7],{

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(849),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-027c3d9f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("19a5e9b2", content, true);

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".btn-download,a.btn-download{text-decoration:none!important;display:block;padding:.4rem;margin:1.4rem .7rem 2.5rem;height:1.8rem;line-height:1.8rem;color:#fff;background:#16ac3a;border-radius:.2rem;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadFooter.vue"],"names":[],"mappings":"AACA,6BAEE,+BAAiC,AACjC,cAAe,AACf,cAAe,AACf,2BAAkC,AAClC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadFooter.vue","sourcesContent":["\n.btn-download,\na.btn-download {\n  text-decoration: none !important;\n  display: block;\n  padding: .4rem;\n  margin: 1.4rem .7rem 2.5rem .7rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  color: #fff;\n  background: #16ac3a;\n  border-radius: .2rem;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'downloadFooter',
    data: function data() {
        return {
            isMatch: false,
            isArticle: false
        };
    },
    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(499);
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
            }
            utilObj.jumpUrl();
        }
    },
    mounted: function mounted() {
        if (window.location.href.indexOf('match') > -1) {
            this.isMatch = true;
        } else {
            this.isArticle = true;
        }
    }
});

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("Download All Football for more matches")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadForComments')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading_circle.eeb3dd9.gif";

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play@80x80.591d439.png";

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAANlBMVEUAAAAWrDoWrDr///+S0Jw1sk/e8OH0+vVgvnG64MCg1anT69eCyo9MuGGt27VyxIHH5czq9ev1UaDxAAAAAnRSTlMAgJsrThgAAAG6SURBVGjetdbbboQwDATQKUNICLft//9sW7QKS63W4NX4KU9HVkaWjU5XHwcusBsusBsusBsusBsusBsusBsusG/g/RizccUm15CNS3YuIRtKG0obShvX7Zru2rhsjxzSTRvX7ePt2z6+kBxS0PY7b3rMRufrAdvB53ToURt/9jw0PUdteFl+62EbXpbHy7ctHtatbfGwbm2Lh3VrWzyqW9vHlzoxT72rW9vHa+Zen8Xqo2N7+LjLjTzpQ7prw9hr+fmaZP59dmwPX19nMQ19PEuLl7NN9uEsLT7u3GE33c/SxzPzyW66m6WPF3J6sYdl2PVIlhbfdrzZqUtND9q28+OM2PUasu2fk0znA+hBziHb4o/ffSYyv2Pjv7twJWvQthM6nMdlJnMK2hYvfNVLJue3bJj1kLdnpiSrY7u40Tn129ZPZug9218Wc2arQN/Omkvjk56Kb/u44fv6qHXpfNvH3YrbUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaX6KvJvp9r+CFAAAAAElFTkSuQmCC"

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_playing.6bf00be.png";

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAbBAMAAABlxgnoAAAAHlBMVEUAAAAWsToWsToWsToWsToWsToWsToWsToWsToWsTo67toGAAAACXRSTlMA89WldEAZjMranF6TAAAAdElEQVQY02MoNGNAgJkTHZA4MycFIHFmTk6Ac6ZIzhSBcyYkz5ypCucwBM2caQbnMDgCjYRz2CyBRsI4DKyaQCNhHAYWoJFwDgPISDgHZGQBnMPQCWRhyCD0IEzDtAfhAoTbMF0NMQjhU+xhADEIM9xQQhQAOhxBLkzIy8kAAAAASUVORK5CYII="

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYAgMAAABl+S6cAAAACVBMVEUAAAAWsToWsTrHpKiuAAAAAnRSTlMAxOqay5EAAAAWSURBVAjXY0hhYADiFUByxcCSEJcAAJCIHnFQ5LU1AAAAAElFTkSuQmCC"

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAclBMVEUYrjdPxxpUyRgfsTQyuilFwx8otS8jszJKxB08viU4vCctty1AwCL////d9dj2/PTH7b1z0Vqi4JWf346D1mhWyDJJwi5OxSun4pR81GxMwzbq+OvG68k2uj+557yd3aKB1Idzz3leyGZQwlio4ayS2Zc2JKO0AAAC4klEQVRYw+1S6XriMAx0W9oEisJVjlJu2vd/xdW5wp/AhW/zY3fLOJZGY3niGNIdd/yXeMKnNSfPTzwsx+EEZ2G4m+fy24mVkZmVjxhbUIiNfkhhBK41SCRohdAu4ZgEatUyfqRhhRGDoaLnalSW3bCqsCIXIgimxpkRuEtr7bEm26nOqWoXf4Xhy3H/tWlWlw1fGFUgymRWFNbH/XbTgABrh7cnYjwiOcH6sNuuPoDxsfrcHQCszwcjGakCIcZWn2613R3WvIaG+SvNPTE1ybj3qlWz2e6Pa5HM0Bpz38Tx1SfDKcDma3902Q2lI2xISIj6tCEBwLf4muqv2ZD0/Qnd6roTcrcU8halWgCQYodX7i86OZvG9FoGQFGPaN+wQ5GDk45XAJQ6opgset6qO8WwQ8BoYAfJACrkYN1byUnr1CkD4Fr9btieYY9Tj2aPZo+TaEgBKLOui9JAurdp6LFhGQBFPeJfMOziQHQpG8WkOgBFQ3c5bgCa8ZJ17ZIGs0jdMgBOq/cBMAbvqkfcZIg2w9FsNhoCtGK4HMBE2ORmQ7urzHAMQ6PD3LCfGfYRFvXJ7ooW+rSrgRFmLkekd0U2TRwSxoDsrlwGmBmdqR5xzpDuStikHUO8K6PDk438yYoRNJcMnyNwI6U+zhGA6/gio0NYKOtb1njOEGBudH5qOMWrEDaBwZRyxDWGjjf6seZz+rHeRIkofDIB7wqjO9rfKfpFw8JdOaaLBgbNYvpcMKwx1lbW8a5EjKhtWlRDc6ldi3dV24h2VllbYq41cnrCXdW+Hk5YuzWnVJ+F3VV9M1J5uXXDh2+laPjwG9ou3FWnxrywZk+JiUkOk22b97CqhKdHMbRFHpay7YbcNUYaaNguxDB+cbhILZy74q1+h+0hfPKjx7gQi9ibHkny8aAxSFkXwhfyxeRv0BVzU2KSZze6cMJHgy4hyY6piWVfI0JwSWgy6RqUe82wZdwN/xy/AJgOhPtV4FANAAAAAElFTkSuQmCC"

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(589);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("4cbbef98", content, true);

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".comments{margin:0;padding:0;width:100%}.comments .sub_line span{display:inline-block;height:20px;font-size:15px;font-weight:600;color:#2d2f32;line-height:20px}.comments .sub_line span:before{display:inline-block;height:24px;width:3px;margin-right:12px;vertical-align:middle;content:\"\";background-color:#16b13a}#comment_list{margin:18px 0;padding:0}#comment_list li{list-style:none;position:relative;padding:0 15px;margin-bottom:12px;overflow:hidden;border-bottom:1px solid #eff1f4}#comment_list .quote{margin:14px 0 6px;padding:10px 12px 8px;background:#eff1f4;color:#999;border-radius:3px}#comment_list .quote .icon_author{position:relative;bottom:1px}#comment_list .quote p{margin:0;font-size:14px;word-break:break-word}#comment_list .quote_author{color:#2d2f32;font-size:14px;height:16px;line-height:16px;margin-bottom:4px}#comment_list .quote_author span{display:inline-block;vertical-align:middle}#comment_list .avatar{position:absolute;top:4px;left:15px;height:30px;width:30px;border-radius:50%}#comment_list .user_info{margin-bottom:0;font-size:14px;width:100%;padding:0}#comment_list .user_info .name{margin:0 0 0 38px;color:#16b13a;float:left}#comment_list .user_info p span{height:20px;line-height:20px;font-size:12px;display:inline-block;vertical-align:middle}#comment_list .icon_v{background-image:url(https://static1.dongqiudi.com/web-new/static/img/V_con_v2.png);background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:13px;width:13px}#comment_list .icon_author{height:16px;line-height:16px;margin-left:4px;font-size:12px;padding:0 4px;background:#16ac3a;color:#fff;border-radius:4px}#comment_list .icon_team{position:relative;bottom:1px;background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:16px;width:16px}#comment_list .user_info .commend{position:relative;top:1px;margin:0;height:20px;line-height:20px;vertical-align:middle;font-size:12px;color:#8c9399;float:right}#comment_list .user_info .commend span{position:relative;bottom:3px;background-image:url(" + __webpack_require__(590) + ");background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:24px;width:24px}#comment_list .user_info .commend .hot{background-image:url(" + __webpack_require__(591) + ");background-position:50%;background-size:100% auto;background-repeat:no-repeat}#comment_list .detail{margin:8px 0 12px;font-size:16px;color:#333}#comment_list .detail .text_con{line-height:24px;margin:0;word-break:break-word}#comment_list .detail .pic_con{margin-top:4px}#comment_list .detail .pic_con .img_con{display:inline-block;position:relative;overflow:hidden}#comment_list .pic_con img{width:100%;border-radius:2px}#comment_list .pic_con .single{max-height:336px;width:73%}#comment_list .pic_con .multiple{width:32%}#comment_list .pic_con .multiple:not(:last-child){margin-right:2%}#comment_list img.face{position:relative;top:-1px;height:24px;width:auto;vertical-align:top}#comment_list .pic_con .media-holder{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%;background:url(" + __webpack_require__(548) + ") no-repeat 50%;background-size:40px 40px}#comment_list .pic_con .media-label{position:absolute;top:0;left:0;background:url(" + __webpack_require__(592) + ") 0 0 no-repeat;width:20px;height:20px;background-size:100% 100%;text-indent:1000px}#comment_list .date{font-size:10px;color:#999;margin:0 0 0 38px}.more_comment{font-size:16px;text-align:center;margin:36px 0}.more_comment>a{color:#16b13a}.more_comment .no_comment{color:#b5bcc4;font-weight:400}.more_comment .message-icon{width:17px;vertical-align:middle;margin-right:9px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/comments.vue"],"names":[],"mappings":"AACA,UACE,SAAU,AACV,UAAW,AACX,UAAY,CACb,AACD,yBACE,qBAAsB,AACtB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,gBAAkB,CACnB,AACD,gCACE,qBAAsB,AACtB,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,sBAAuB,AACvB,WAAY,AACZ,wBAA0B,CAC3B,AACD,cACE,cAAoB,AACpB,SAAW,CACZ,AACD,iBACE,gBAAiB,AACjB,kBAAmB,AACnB,eAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,+BAAiC,CAClC,AACD,qBACE,kBAAmB,AACnB,sBAAuB,AACvB,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACpB,AACD,kCACE,kBAAmB,AACnB,UAAY,CACb,AACD,uBACE,SAAU,AACV,eAAgB,AAChB,qBAAuB,CACxB,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,iCACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,sBACE,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB,AACD,yBACE,gBAAiB,AACjB,eAAgB,AAChB,WAAY,AACZ,SAAW,CACZ,AACD,+BACE,kBAAmB,AACnB,cAAe,AACf,UAAY,CACb,AACD,gCACE,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,qBAAsB,AACtB,qBAAuB,CACxB,AACD,sBACE,oFAAqF,AACrF,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,2BACE,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,WAAe,AACf,iBAAmB,CACpB,AACD,yBACE,kBAAmB,AACnB,WAAY,AACZ,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,kCACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,eAAgB,AAChB,cAAe,AACf,WAAa,CACd,AACD,uCACE,kBAAmB,AACnB,WAAY,AACZ,+CAAoD,AACpD,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,uCACE,+CAAoD,AACpD,wBAAmC,AACnC,0BAA2B,AAC3B,2BAA6B,CAC9B,AACD,sBACE,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACb,AACD,gCACE,iBAAkB,AAClB,SAAU,AACV,qBAAuB,CACxB,AACD,+BACE,cAAgB,CACjB,AACD,wCACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAiB,CAClB,AACD,2BACE,WAAY,AACZ,iBAAmB,CACpB,AACD,+BACE,iBAAkB,AAClB,SAAW,CACZ,AACD,iCACE,SAAW,CACZ,AACD,kDACE,eAAiB,CAClB,AACD,uBACE,kBAAmB,AACnB,SAAU,AACV,YAAa,AACb,WAAY,AACZ,kBAAoB,CACrB,AACD,qCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,YAAa,AACb,uDAAkE,AAClE,yBAA2B,CAC5B,AACD,oCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,uDAA0D,AAC1D,WAAY,AACZ,YAAa,AACb,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,oBACE,eAAgB,AAChB,WAAe,AACf,iBAAmB,CACpB,AACD,cACE,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,gBACE,aAAe,CAChB,AACD,0BACE,cAAe,AACf,eAAiB,CAClB,AACD,4BACE,WAAY,AACZ,sBAAuB,AACvB,gBAAkB,CACnB","file":"comments.vue","sourcesContent":["\n.comments {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n.comments .sub_line span {\n  display: inline-block;\n  height: 20px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #2d2f32;\n  line-height: 20px;\n}\n.comments .sub_line span:before {\n  display: inline-block;\n  height: 24px;\n  width: 3px;\n  margin-right: 12px;\n  vertical-align: middle;\n  content: \"\";\n  background-color: #16b13a;\n}\n#comment_list {\n  margin: 18px 0 18px;\n  padding: 0;\n}\n#comment_list li {\n  list-style: none;\n  position: relative;\n  padding: 0 15px 0 15px;\n  margin-bottom: 12px;\n  overflow: hidden;\n  border-bottom: solid #eff1f4 1px;\n}\n#comment_list .quote {\n  margin: 14px 0 6px;\n  padding: 10px 12px 8px;\n  background: #eff1f4;\n  color: #999;\n  border-radius: 3px;\n}\n#comment_list .quote .icon_author {\n  position: relative;\n  bottom: 1px;\n}\n#comment_list .quote p {\n  margin: 0;\n  font-size: 14px;\n  word-break: break-word;\n}\n#comment_list .quote_author {\n  color: #2d2f32;\n  font-size: 14px;\n  height: 16px;\n  line-height: 16px;\n  margin-bottom: 4px;\n}\n#comment_list .quote_author span {\n  display: inline-block;\n  vertical-align: middle;\n}\n#comment_list .avatar {\n  position: absolute;\n  top: 4px;\n  left: 15px;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n#comment_list .user_info {\n  margin-bottom: 0;\n  font-size: 14px;\n  width: 100%;\n  padding: 0;\n}\n#comment_list .user_info .name {\n  margin: 0 0 0 38px;\n  color: #16b13a;\n  float: left;\n}\n#comment_list .user_info p span {\n  height: 20px;\n  line-height: 20px;\n  font-size: 12px;\n  display: inline-block;\n  vertical-align: middle;\n}\n#comment_list .icon_v {\n  background-image: url(https://static1.dongqiudi.com/web-new/static/img/V_con_v2.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 13px;\n  width: 13px;\n}\n#comment_list .icon_author {\n  height: 16px;\n  line-height: 16px;\n  margin-left: 4px;\n  font-size: 12px;\n  padding: 0 4px;\n  background: #16ac3a;\n  color: #ffffff;\n  border-radius: 4px;\n}\n#comment_list .icon_team {\n  position: relative;\n  bottom: 1px;\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n}\n#comment_list .user_info .commend {\n  position: relative;\n  top: 1px;\n  margin: 0;\n  height: 20px;\n  line-height: 20px;\n  vertical-align: middle;\n  font-size: 12px;\n  color: #8c9399;\n  float: right;\n}\n#comment_list .user_info .commend span {\n  position: relative;\n  bottom: 3px;\n  background-image: url(../assets/icon_agree_def.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 24px;\n  width: 24px;\n}\n#comment_list .user_info .commend .hot {\n  background-image: url(../assets/icon_agree_hot.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n}\n#comment_list .detail {\n  margin: 8px 0 12px;\n  font-size: 16px;\n  color: #333;\n}\n#comment_list .detail .text_con {\n  line-height: 24px;\n  margin: 0;\n  word-break: break-word;\n}\n#comment_list .detail .pic_con {\n  margin-top: 4px;\n}\n#comment_list .detail .pic_con .img_con {\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n#comment_list .pic_con img {\n  width: 100%;\n  border-radius: 2px;\n}\n#comment_list .pic_con .single {\n  max-height: 336px;\n  width: 73%;\n}\n#comment_list .pic_con .multiple {\n  width: 32%;\n}\n#comment_list .pic_con .multiple:not(:last-child) {\n  margin-right: 2%;\n}\n#comment_list img.face {\n  position: relative;\n  top: -1px;\n  height: 24px;\n  width: auto;\n  vertical-align: top;\n}\n#comment_list .pic_con .media-holder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background: url(../assets/play@80x80.png) no-repeat center center;\n  background-size: 40px 40px;\n}\n#comment_list .pic_con .media-label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: url(../assets/gif_comments.png) 0 0 no-repeat;\n  width: 20px;\n  height: 20px;\n  background-size: 100% 100%;\n  text-indent: 1000px;\n}\n#comment_list .date {\n  font-size: 10px;\n  color: #999999;\n  margin: 0 0 0 38px;\n}\n.more_comment {\n  font-size: 16px;\n  text-align: center;\n  margin: 36px 0;\n}\n.more_comment > a {\n  color: #16b13a;\n}\n.more_comment .no_comment {\n  color: #b5bcc4;\n  font-weight: 400;\n}\n.more_comment .message-icon {\n  width: 17px;\n  vertical-align: middle;\n  margin-right: 9px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 590:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAWlBMVEUAAAC1vMS2vMS2vcS2vMS1vMS2vMS2vcS1vMS2vcS1vMS2vMS2vcS1vMS1vMS1vMS2vMS2vcS2vMS1vMS1vMS2vcS2vcS2vcS2vcS2vcS2vcS1vMS1vMO1vMT8uFU+AAAAHXRSTlMAiO/jM/O9mmIt+thEGAm1cFNMPiDKrKOReBEPgCLrUWEAAADcSURBVEjH7dLJkoMgAEVRhBYZgvPUmvv/v9mmExephCpYJ3fh6p0qVMS3zy7MslzqDDAB6PS9hUbDkAw6sLvjmgxaCEJRJYOKUgjPkgwUze2xpu4NdCLAb+J+lKha9NCn7Qf1P13B9JejIcSW+7ZtY9dwP4viLPa1NI9Kc/93Z7GXOefVKI5q+/Po4vERoFsDr1duxUVAcXu8O6vPA5IqC1gwWcCATQbnTcwCEzoL1I4iCwzQZYEWQhaYUSILKOYomIriUE9dF2gjwPE+v0dAIY9Alk9z14zi2yf2B8c9GmLvZWM/AAAAAElFTkSuQmCC"

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAArlBMVEUAAAD/iwP/iwP/iwP/iwP/iwL/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/7tr/hgD/q0j//Pf/fQD/ggD/jAL/iQD/kA7/8+T/9+7/eQD/6c3///7/79z/x4X/+fH/p0D/8eD/w33/r1H/nir/lBb/9ej/4b7/1aL/vG3/t2H/3LL/mSH/2Kv/zpSgIcxxAAAAGnRSTlMA8Ob0Kfvsp5veThGPajkhA8e8gnFhWFNHrRtt3BkAAAFOSURBVEjH7dPZboJQFIVhEVAE57lsYO8DCMg8avv+L1ZtiWkipHCt/8XhZn0kJJzBu9dOkUacpHTfL1eESOvuYE6QJEDHzmDHoMgZTDuDLbBCNWHcGUhAeS8wwWvomCB13c/IqNyCwabjXhgh5G6JbN5tfxwxo9TtAMXZYS/L8kFofbOwWAjyB4GhWXpuIqsTpWXjfszzPCcSAVZW5p9PUIdA20ZwnyIySAs7U8NLdL4XRecohUkj4OFaVpV5il1PVVXLrvNdzeAbAWdoru+ZJ01X/2apCa5aQeY8AftCMG0DuvUM9C+kXQ/g2SXSvAcIvQCHSg9gOSmsBz1A9slg2gf4EbJ9H6DHKAr/Ac/zHt9sJThZtoHYdcP7r+Hbvl7nOu03lYdU0wK6nUEQaHVxAjRrASKBYSD7OY1HSBOlBWxGw1sc9/t4NF4M3r1i36NFPw3ZWKZpAAAAAElFTkSuQmCC"

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAOVBMVEUAAAAWsToWsTr///9dwW/1+/aM0Jcztk7g8uO/5MTr9uym2q5uxn3W7dl+y4tKvF/K6M+z37qa1aPYmHFUAAAAAnRSTlMAgJsrThgAAAD3SURBVEjHldPdrgIhDATgObYsC+yPnvd/WLUb0xiwZOaCq35kIIAbmz/wArwAK8ZEH6HAQKQ1RwK8wA+RfwuMxZK0F2OSk2xvIQY70RMbThqIjqiaabHAV6tkZiLQtbI1EEZC46In25Z746InRxVJi5s6FE5sprU9ezd1MSabFLukUiatnNzTJURK3MqJlEuU1Yy6iImmcsurLFErJ9WqvDd/iEbCSZP2eTN7KJzkevXJazqnAp+fJfftXKocLgJiOXd5paqLmFj0vx3zczjxzAV4AV6AF+AFeAFegBfgBXgBXoAX4AV4AV6AF+AFeAFegBfgBXjxBN/6DSG9vEEQAAAAAElFTkSuQmCC"

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'comments',
    props: ['articleId', 'time'],
    data: function data() {
        return {
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
            componentsShow: false,
            comments: [],
            type: 'normal',
            article_id: this.articleId,
            loadComments: false
        };
    },

    methods: {
        init: function init() {
            var that = this;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/m/archives/recommend_comments/' + this.article_id + '?plat=m').then(function (response) {
                that.type = response.data.type;
                if (response.data.comments && response.data.comments.length > 0) {
                    that.loadComments = true;
                } else {
                    return;
                }
                for (var i = 0; i < response.data.comments.length; i++) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(that.comments, i, response.data.comments[i]);
                }
            }, function (error) {});
        },
        formatDate: function formatDate(gmtDate) {
            Date.prototype.Format = function (fmt) {
                var o = {
                    'M+': this.getMonth() + 1,
                    'd+': this.getDate(),
                    'h+': this.getHours(),
                    'm+': this.getMinutes(),
                    's+': this.getSeconds(),
                    'q+': Math.floor((this.getMonth() + 3) / 3),
                    'S': this.getMilliseconds() };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
                for (var k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
                }return fmt;
            };
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diff_min = new Date().getTimezoneOffset();
            var local_date = new Date(date - diff_min * 60 * 1000);
            var same_year = local_date.getFullYear() === new Date().getFullYear();
            return local_date.Format(same_year ? 'MM-dd hh:mm' : 'yyyy-MM-dd hh:mm');
        }
    },
    mounted: function mounted() {
        this.init();
    }
});

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadComments) ? _c('div', {
    staticClass: "comments"
  }, [_c('div', {
    staticClass: "sub_line"
  }, [(_vm.type === 'recommend') ? _c('span', [_vm._v("Hot comments")]) : _c('span', [_vm._v("Latest comments")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "comment_list"
    }
  }, _vm._l((_vm.comments), function(com) {
    return _c('li', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "alt": "avatar",
        "src": _vm.getImgSrc(com.user.avatar),
        "onerror": "javascript:this.src='https://img1.dongqiudi.com/fastdfs1/M00/3B/EF/o4YBAFjM9lqAel9GAAAQrsgeQ3A103.jpg'"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_info"
    }, [_c('p', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(com.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.user.medal_id != 0)),
        expression: "(com.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.user.is_root),
        expression: "com.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("author")])]), _vm._v(" "), _c('p', {
      staticClass: "commend"
    }, [_vm._v("\n                    " + _vm._s(com.up) + "\n                    "), _c('span', {
      class: {
        hot: _vm.type === 'recommend'
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(com.created_at)))]), _vm._v(" "), (com.quote) ? _c('div', {
      staticClass: "quote"
    }, [_c('div', {
      staticClass: "quote_author"
    }, [_c('span', [_vm._v(_vm._s(com.quote.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.quote.user.medal_id != 0)),
        expression: "(com.quote.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.quote.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.quote.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.quote.user.is_root),
        expression: "com.quote.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("author")])]), _vm._v(" "), _c('p', {
      staticClass: "quote_con",
      domProps: {
        "innerHTML": _vm._s(com.quote.content)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('p', {
      staticClass: "text_con",
      domProps: {
        "innerHTML": _vm._s(com.content)
      }
    }), _vm._v(" "), ((_vm.imgMode = 'on')) ? _c('div', {
      staticClass: "pic_con"
    }, _vm._l((com.attachments), function(pic) {
      return _c('div', {
        staticClass: "img_con",
        class: (com.attachments_total > 1) ? 'multiple' : 'single'
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(pic.thumb)
        }
      }), _vm._v(" "), (pic.mime === 'image/gif') ? [_c('div', {
        staticClass: "media-holder"
      }), _vm._v(" "), _c('div', {
        staticClass: "media-label"
      })] : _vm._e()], 2)
    })) : _c('div', [_vm._v("\n                    [images]\n                ")])])])
  })), _vm._v(" "), (_vm.isInApp) ? _c('div', {
    staticClass: "more_comment"
  }, [(_vm.comments.length > 0) ? _c('a', {
    attrs: {
      "href": 'allfootball:///comment/' + _vm.article_id
    }
  }, [_c('img', {
    staticClass: "message-icon",
    attrs: {
      "src": __webpack_require__(595),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('readMore')) + " >\n        ")]) : _c('a', {
    staticClass: "no_comment",
    attrs: {
      "href": 'allfootball:///post_comments/' + _vm.article_id
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('noCommented')) + "\n        ")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_message.26ff204.jpg";

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("a1efac3c", content, true);

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".operamini-tips[data-v-027c3d9f]{background:#ff0;text-align:center;font-weight:700}.links[data-v-027c3d9f]{font-size:14px;padding:0 15px;color:#fff}.links a[data-v-027c3d9f]{color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/AppTweet.vue"],"names":[],"mappings":"AACA,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB,AACD,wBACE,eAAgB,AAChB,eAAuB,AACvB,UAAY,CACb,AACD,0BACE,UAAY,CACb","file":"AppTweet.vue","sourcesContent":["\n.operamini-tips[data-v-027c3d9f] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n.links[data-v-027c3d9f] {\n  font-size: 14px;\n  padding: 0 15px 0 15px;\n  color: #fff;\n}\n.links a[data-v-027c3d9f] {\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tweetCon_vue__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tweetCon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tweetCon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comments_vue__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_comments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadFooter_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_downloadFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_downloadFooter_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            title: '',
            article_id: parseInt(this.$route.query.id, 10),
            bodyLoad: false,
            loadItem: false,
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },

    computed: {
        articleInfo: function articleInfo() {
            return this.$store.state.tweetStore.articleInfo[this.article_id] || {};
        }
    },
    asyncData: function asyncData(_ref) {
        var store = _ref.store,
            id = _ref.route.query.id;

        if (id) {
            return store.dispatch('getArticleInfo', { article_id: id });
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
        }
    },
    head: function head() {
        var isHaveMedia = this.articleInfo && this.articleInfo.entities || null;
        var HOST =  true ? 'https://m.allfootballapp.com' : 'https://test-m.allfootballapp.com';
        var title = (this.articleInfo && this.articleInfo.text || '') + '| All Football';
        var shareUrl = HOST + this.$route.fullPath;
        var shareImg = isHaveMedia && isHaveMedia.media && isHaveMedia.media.photo && isHaveMedia.media.photo[0] && isHaveMedia.media.photo[0].original.url || isHaveMedia && isHaveMedia.media && isHaveMedia.media.video && isHaveMedia.media.video.cover || 'http://img.allfootballapp.com/www/M00/52/A6/rB8CLF1hHy2AWL55AAm0BGPys88585.png';
        var description = this.articleInfo && this.articleInfo.text || 'Visit All Football to get football news, live scores, highlights, videos and commentary for EPL, La Liga, Bundesliga, Serie A';
        var keywords = 'All Football';
        var link = [];
        return {
            title: title,
            link: link,
            meta: [{
                name: 'description',
                content: description.replace(/<(.*?)>/g, '')
            }, {
                name: 'keywords',
                content: keywords
            }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@allfootballapp' }, { name: 'twitter:creator', content: '@allfootballapp' }, { name: 'twitter:app:id:ipad', content: '' }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: title }, { name: 'twitter:image', content: shareImg }, { name: 'fb:app_id', content: 'summary_large_image' }, { name: 'og:url', content: shareUrl }, { name: 'og:type', content: 'article' }, { name: 'og:title', content: title }, { name: 'og:description', content: title }, { name: 'og:image', content: shareImg }, { name: 'og:site_name', content: 'AllfootballOfficial' }]
        };
    },

    created: function created() {},
    mounted: function mounted() {
        var query = this.$route.query || {};
        if (window.history && query.type && query.type === 'tweet') {
            var fullPath = this.$route.fullPath;
            console.log(fullPath);
            history.replaceState(null, 'share', '/home?utm_source=APP_SHARE');
            history.pushState(null, 'share', fullPath);

            window.addEventListener('popstate', function (event) {
                if (location.pathname !== '/tweet') {
                    location.reload();
                }
            });
        }
        var mainwrap = document.getElementById('mainwrap');
        if (!this.articleInfo) return;
        this.bodyLoad = true;
        if (mainwrap.offsetHeight - window.screen.height - 100 > 0) {
            this.loadItem = false;
            window.addEventListener('scroll', this.loadmoreFn, false);
        } else {
            this.loadItem = true;
        }
    },
    methods: {
        loadmoreFn: function loadmoreFn() {
            if ((document.documentElement.scrollTop || document.body.scrollTop) > 10) {
                if (this.loadItem) return;
                this.loadItem = true;
                window.removeEventListener('scroll', this.loadmoreFn, false);
            }
        }
    },
    components: {
        tweetCon: __WEBPACK_IMPORTED_MODULE_2__components_tweetCon_vue___default.a, comments: __WEBPACK_IMPORTED_MODULE_3__components_comments_vue___default.a, downloadFooter: __WEBPACK_IMPORTED_MODULE_4__components_downloadFooter_vue___default.a
    }
});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(848),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(846);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("738de8a2", content, true);

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".con{margin:auto 12px}article video{display:block;width:100%;margin:0;background:#3e3e3e no-repeat 50%;background-size:118px;border-radius:1px;-moz-border-radius:1px;-webkit-border-radius:1px}article a{color:#399e5c}.media-container{display:block;position:relative;z-index:1000;margin:0 auto}.img-wrap{margin:10px auto;overflow:hidden}.img-wrap .img-container{width:100%;float:left;overflow:hidden;position:relative;margin-bottom:10px}.img-wrap .img-container img{width:100%}.media-loader{background:url(" + __webpack_require__(547) + ") #e9e9e9 no-repeat 50%;opacity:.3;-webkit-opacity:.3;-moz-opacity:.3;background-size:20px 20px}.media-holder,.media-loader{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%}.media-holder{background:url(" + __webpack_require__(548) + ") no-repeat 50%;background-size:40px 40px}.media-label{position:absolute;top:0;left:0;background:url(" + __webpack_require__(580) + ") 0 0 no-repeat;width:33px;height:33px;background-size:100% 100%;text-indent:1000px}.media-loading{background:url(" + __webpack_require__(547) + ") #e9e9e9 no-repeat 50%;filter:alpha(opacity=30);opacity:.3;background-size:20px 20px}.img-off-holder{width:100%;height:auto;text-align:center;display:table-cell;vertical-align:middle}article .video{position:relative}article .video .mask{width:100%;height:100%;position:absolute;top:0;left:0;background:url(" + __webpack_require__(581) + ") 50% no-repeat rgba(0,0,0,.5);background-size:auto 20px;z-index:10000;display:none}.media-container-video{background-repeat:no-repeat;background-position:50%;background-size:cover;background-color:rgba(0,0,0,.5);border-bottom:20px solid #000;border-top:20px solid #000;width:100%;background-image:url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png)}.media-holder-video{background:url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat 50%;background-size:48px auto}.fade-enter-active{transition:opacity 1.5s}.fade-enter{opacity:0}a.product_box:visited{color:#333}.audio{background-color:#fff;overflow:hidden;padding:4px;position:relative;margin:24px auto;border:1px solid #e9e9e9;height:40px}.audio a{width:40px;height:40px;float:right;margin-top:-43px}.audio a.play{background:url(" + __webpack_require__(582) + ") 50% no-repeat;background-size:12px}.audio a.pause{background:url(" + __webpack_require__(583) + ") 50% no-repeat;background-size:12px}.audio .main{padding-left:50px;background:url(" + __webpack_require__(584) + ") 0 0 no-repeat;background-size:40px 40px}.audio .main h3{height:24px;line-height:24px;font-size:14px;color:#2d2f32;font-weight:400;margin:0;padding:0}.audio .main p{height:20px;line-height:20px;font-size:12px;color:#8c9399;margin:0;padding:0}.audio .progress{position:absolute;height:2px;bottom:0;left:0;z-index:100;background:#55c818}.audio audio{position:absolute;display:none}.tips{margin-top:-20px;color:#888}.tips,.tips_v{display:block;width:100%;font-size:.8em;line-height:1.5}.tips_v{color:#8c9399}.author-container{padding-top:10px;padding-bottom:5px;overflow:hidden}.author-container .author-name{font-size:1rem;font-family:SFUIDisplay-Bold;font-weight:700;color:#2d2f32;float:left;margin-left:12px;padding-top:6px}.author-container .author-avatar{width:45px;height:45px;border-radius:50%;float:left;margin:0}.article-content{font-size:1rem;font-family:SFUIDisplay-Regular;font-weight:400;color:#2d2f32;line-height:22px;margin-top:5px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/tweetCon.vue"],"names":[],"mappings":"AACA,KACE,gBAAkB,CACnB,AACD,cACE,cAAe,AACf,WAAY,AACZ,SAAU,AACV,iCAA4C,AAC5C,sBAAuB,AACvB,kBAAmB,AACnB,uBAAwB,AACxB,yBAA2B,CAC5B,AACD,UACE,aAAe,CAChB,AACD,iBACE,cAAe,AACf,kBAAmB,AACnB,aAAc,AACd,aAAe,CAChB,AACD,UACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,yBACE,WAAY,AACZ,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,6BACE,UAAY,CACb,AACD,cAOE,+DAA8E,AAC9E,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,yBAA2B,CAC5B,AACD,4BAZE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,WAAa,CAgBd,AATD,cAOE,uDAAkE,AAClE,yBAA2B,CAC5B,AACD,aACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,uDAAiD,AACjD,WAAY,AACZ,YAAa,AACb,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,eACE,+DAA8E,AAC9E,yBAA0B,AAC1B,WAAa,AACb,yBAA2B,CAC5B,AACD,gBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,eACE,iBAAmB,CACpB,AACD,qBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,sEAAuF,AACvF,0BAA2B,AAC3B,cAAe,AACf,YAAc,CACf,AACD,uBACE,4BAA6B,AAC7B,wBAAmC,AACnC,sBAAuB,AACvB,gCAAqC,AACrC,8BAAkC,AAClC,2BAA+B,AAC/B,WAAY,AACZ,6GAA+G,CAChH,AACD,oBACE,gHAA2H,AAC3H,yBAA2B,CAC5B,AACD,mBACE,uBAAyB,CAC1B,AACD,YACE,SAAW,CACZ,AACD,sBACE,UAAe,CAChB,AACD,OACE,sBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,yBAA0B,AAC1B,WAAa,CACd,AACD,SACE,WAAY,AACZ,YAAa,AACb,YAAa,AACb,gBAAkB,CACnB,AACD,cACE,uDAAiE,AACjE,oBAAsB,CACvB,AACD,eACE,uDAAkE,AAClE,oBAAsB,CACvB,AACD,aACE,kBAAmB,AACnB,uDAAsD,AACtD,yBAA2B,CAC5B,AACD,gBACE,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,eACE,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,SAAU,AACV,SAAW,CACZ,AACD,iBACE,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,OAAQ,AACR,YAAa,AACb,kBAAoB,CACrB,AACD,aACE,kBAAmB,AACnB,YAAc,CACf,AACD,MACE,iBAAkB,AAIlB,UAAe,CAEhB,AACD,cANE,cAAe,AACf,WAAY,AACZ,eAAiB,AAEjB,eAAiB,CAQlB,AAND,QAIE,aAAe,CAEhB,AACD,kBACE,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CAClB,AACD,+BACE,eAAgB,AAChB,6BAA8B,AAC9B,gBAAkB,AAClB,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAiB,CAClB,AACD,iCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX,AACD,iBACE,eAAgB,AAChB,gCAAiC,AACjC,gBAAiB,AACjB,cAAe,AACf,iBAAkB,AAClB,cAAgB,CACjB","file":"tweetCon.vue","sourcesContent":["\n.con {\n  margin: auto 12px;\n}\narticle video {\n  display: block;\n  width: 100%;\n  margin: 0;\n  background: #3e3e3e no-repeat center center;\n  background-size: 118px;\n  border-radius: 1px;\n  -moz-border-radius: 1px;\n  -webkit-border-radius: 1px;\n}\narticle a {\n  color: #399e5c;\n}\n.media-container {\n  display: block;\n  position: relative;\n  z-index: 1000;\n  margin: 0 auto;\n}\n.img-wrap {\n  margin: 10px auto;\n  overflow: hidden;\n}\n.img-wrap .img-container {\n  width: 100%;\n  float: left;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 10px;\n}\n.img-wrap .img-container img {\n  width: 100%;\n}\n.media-loader {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;\n  opacity: .3;\n  -webkit-opacity: .3;\n  -moz-opacity: .3;\n  background-size: 20px 20px;\n}\n.media-holder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background: url(../assets/play@80x80.png) no-repeat center center;\n  background-size: 40px 40px;\n}\n.media-label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: url(../assets/gif.png) 0 0 no-repeat;\n  width: 33px;\n  height: 33px;\n  background-size: 100% 100%;\n  text-indent: 1000px;\n}\n.media-loading {\n  background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;\n  filter: alpha(opacity=30);\n  opacity: 0.3;\n  background-size: 20px 20px;\n}\n.img-off-holder {\n  width: 100%;\n  height: auto;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n}\narticle .video {\n  position: relative;\n}\narticle .video .mask {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: url(../assets/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);\n  background-size: auto 20px;\n  z-index: 10000;\n  display: none;\n}\n.media-container-video {\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-bottom: 20px solid #000000;\n  border-top: 20px solid #000000;\n  width: 100%;\n  background-image: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png);\n}\n.media-holder-video {\n  background: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat center center;\n  background-size: 48px auto;\n}\n.fade-enter-active {\n  transition: opacity 1.5s;\n}\n.fade-enter {\n  opacity: 0;\n}\na.product_box:visited {\n  color: #333333;\n}\n.audio {\n  background-color: #ffffff;\n  overflow: hidden;\n  padding: 4px;\n  position: relative;\n  margin: 24px auto;\n  border: 1px solid #e9e9e9;\n  height: 40px;\n}\n.audio a {\n  width: 40px;\n  height: 40px;\n  float: right;\n  margin-top: -43px;\n}\n.audio a.play {\n  background: url(../assets/icon_play.png) center center no-repeat;\n  background-size: 12px;\n}\n.audio a.pause {\n  background: url(../assets/icon_pause.png) center center no-repeat;\n  background-size: 12px;\n}\n.audio .main {\n  padding-left: 50px;\n  background: url(../assets/bg_music.png) 0 0 no-repeat;\n  background-size: 40px 40px;\n}\n.audio .main h3 {\n  height: 24px;\n  line-height: 24px;\n  font-size: 14px;\n  color: #2d2f32;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n}\n.audio .main p {\n  height: 20px;\n  line-height: 20px;\n  font-size: 12px;\n  color: #8c9399;\n  margin: 0;\n  padding: 0;\n}\n.audio .progress {\n  position: absolute;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  background: #55c818;\n}\n.audio audio {\n  position: absolute;\n  display: none;\n}\n.tips {\n  margin-top: -20px;\n  display: block;\n  width: 100%;\n  font-size: 0.8em;\n  color: #888888;\n  line-height: 1.5;\n}\n.tips_v {\n  display: block;\n  width: 100%;\n  font-size: 0.8em;\n  color: #8c9399;\n  line-height: 1.5;\n}\n.author-container {\n  padding-top: 10px;\n  padding-bottom: 5px;\n  overflow: hidden;\n}\n.author-container .author-name {\n  font-size: 1rem;\n  font-family: SFUIDisplay-Bold;\n  font-weight: bold;\n  color: #2D2F32;\n  float: left;\n  margin-left: 12px;\n  padding-top: 6px;\n}\n.author-container .author-avatar {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  float: left;\n  margin: 0;\n}\n.article-content {\n  font-size: 1rem;\n  font-family: SFUIDisplay-Regular;\n  font-weight: 400;\n  color: #2D2F32;\n  line-height: 22px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tweetArticleCon',
    data: function data() {
        return {
            baseUrl: global.apiDomain,
            imgMode: 'loading',
            con: [],
            video_height: 0,
            UUID: '',
            isHaveMedia: this.articleInfo.entities
        };
    },
    props: ['articleInfo'],
    created: function created() {},
    mounted: function mounted() {
        var mainWidth = document.documentElement.clientWidth || window.screen.width;
        this.video_height = (mainWidth - 30) * 9 / 16 - 40;
    },

    methods: {
        checkMode: function checkMode(item) {
            var android_mode = item.android_mode;
            var ios_mode = item.ios_mode;
            if (android_mode == 'player') {
                return true;
            }
            if (ios_mode == 'player') {
                return true;
            }
            return false;
        },

        videoPlay: function videoPlay(url) {
            if (url) {
                location.href = url;
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "con",
    attrs: {
      "id": "articleMain"
    }
  }, [(_vm.articleInfo.author) ? _c('div', {
    staticClass: "author-container"
  }, [_c('img', {
    staticClass: "author-avatar",
    attrs: {
      "src": _vm.articleInfo.author && _vm.articleInfo.author.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.articleInfo.author && _vm.articleInfo.author.name))])]) : _vm._e(), _vm._v(" "), (_vm.articleInfo.text) ? _c('div', {
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.articleInfo.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.photo && _vm.isHaveMedia.media.photo.length) ? _c('div', {
    staticClass: "img-wrap"
  }, _vm._l((_vm.isHaveMedia.media.photo), function(item) {
    return _c('div', {
      key: item.original.url,
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "article-img",
      attrs: {
        "src": item.original.url
      }
    })])
  })) : _vm._e(), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video) ? _c('div', {
    staticClass: "video-wrap"
  }, [(_vm.checkMode(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video)) ? _c('section', {
    staticClass: "video"
  }, [_c('video', {
    style: ('background:url(' + _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover + ') top center no-repeat rgba(0,0,0,0.7);background-size: cover;height:' + _vm.video_height + 'px'),
    attrs: {
      "src": _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url,
      "controls": "controls"
    },
    on: {
      "play": function($event) {
        _vm.videoPlay()
      }
    }
  })]) : _c('div', [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover) ? _c('div', {
    staticClass: "media-container media-container-video",
    style: ({
      'backgroundImage': 'url(' + _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover + ')',
      'height': _vm.video_height + 'px'
    }),
    on: {
      "click": function($event) {
        _vm.videoPlay(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url)
      }
    }
  }, [_c('div', {
    staticClass: "media-holder media-holder-video"
  })]) : _c('div', {
    staticClass: "media-container media-container-video",
    style: ({
      'height': _vm.video_height + 'px'
    }),
    on: {
      "click": function($event) {
        _vm.videoPlay(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url)
      }
    }
  }, [_c('div', {
    staticClass: "media-holder media-holder-video"
  })])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "id": "mainwrap"
    }
  }, [_c('tweetCon', {
    attrs: {
      "articleInfo": _vm.articleInfo
    }
  }), _vm._v(" "), (_vm.loadItem) ? _c('comments', {
    attrs: {
      "articleId": _vm.article_id,
      "time": 3000
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bodyLoad && _vm.loadItem && !_vm.isInApp) ? _vm._m(0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadFooter', {
    attrs: {
      "text": "Download All Football for more comments"
    }
  })
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.b3e5bed49b933a919fba.js